module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_html.js
// module id = 26
// module chunks = 0